import { MemberSearchResultDto, WorkflowDto, MemberDto, DependantDto, MembershipDto, TicketModeEnum, MemberSearchResultListDto } from '../../../service/dto';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpWorkflowService } from '../../../service/http-workflow.service';
import { finalize, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpTicketService } from '../../../service/http-ticket.service';
import { environment } from '../../../../environments/environment';
import { PolicyDto } from '../../../service/dto-insurance';

@Component({
	selector: 'app-ticket-member-search',
	standalone: false,
	templateUrl: './ticket-member-search.component.html',
	styleUrl: './ticket-member-search.component.scss'
})
export class TicketMemberSearchComponent implements OnInit, OnDestroy {
	ticketMode!: TicketModeEnum;
	workflows!: WorkflowDto[];
	results?: MemberSearchResultListDto;
	showMemberAndDependantTab: boolean = true;
	showPolicyTab = false;

	searchForm!: FormGroup;

	loading = false;
	subscription = new Subscription();

	constructor(
		private fb: FormBuilder,
		private ticketService: HttpTicketService,
		private activatedRoute: ActivatedRoute,
		private router: Router) {
		this.searchForm = this.fb.group({
			search: ['', Validators.required]
		});
		this.showPolicyTab = environment.enableProductAndPolicy;
	}

	ngOnInit(): void {
		this.subscription.add(this.activatedRoute.params.subscribe(params => {
			this.ticketMode = params['ticketMode']!;
			if(environment.enableProductAndPolicy && this.ticketMode == 'Claim'){
				this.showPolicyTab=true;
				this.showMemberAndDependantTab=false;
			}else{
				this.showMemberAndDependantTab=true;
				this.showPolicyTab=false;
			}

			this.loading = true;
			this.ticketService.getWorkflows(this.ticketMode).pipe(
				finalize(() => {
					this.loading = false;
				})
			).subscribe(result => this.workflows = result);
		}));
	}
	ngOnDestroy(): void {

	}
	doSearch() {
		this.ticketService.search(this.searchForm.get('search')!.value).subscribe(result => {
			this.results = result;
		});
	}
}
